export const customPaymentMethods = {
    payOnDelivery: "cashondelivery",
    zeroValueOrder: "free",
};
//# sourceMappingURL=PaymentMethods.js.map